View = require 'app/scripts/views/internal/view'
t = require('app/scripts/views/internal/teacup-with-helpers')('onboarding')
React = require 'react'
ReactDOM = require 'react-dom'
WelcomeComponent = require 'app/scripts/views/onboarding/welcome'

module.exports = class WelcomeView extends View
  tagName: 'div'
  className: 'welcome-wrapper'

  render: ->
    @$el.html(t.renderable => t.div '.js-welcome')

    ReactDOM.render(
      React.createElement(WelcomeComponent, {}),
      @$('.js-welcome')[0]
    )

    @
